import React, { Component } from 'react';
import styled from 'styled-components';
// import Button from '@vzrf/react-button';
import { Button } from '@vds/buttons';
import { calculateRem } from '@uie/javascript-style-helpers';
import { breakpoints } from '@vzrf/react-theme-helpers';
import SelectedChannelsDisplay from './fios-five-pick-channels-components/selectedChannelsDisplay';
import ChannelListComponent from './fios-five-pick-channels-components/channelListComponent';
import * as action from '../../../action/buildProduct';
import { Modal, ModalTitle, ModalBody } from '@vds/modals';
import { Title } from '@vds/typography';
import { connect } from 'react-redux';
import { TitleLockup } from '@vds/type-lockups';
import FiosFiveChannelReviewComponent from './FiosFiveChannelReview';
import { InHomeUtils } from '../../../util/inhomeUtils';

import './FiosFive.scss'
import { updateSCTags } from '../../../service/dtmTag';

const HeaderContainer = styled.div`
    margin: ${calculateRem(30, 20, 10)};
    @media (min-width: 768px) {
        margin: ${calculateRem(10, 20, 0)};
      }
      
      @media (max-width:767px){
        margin-top:1em!important;
    }

`;
//was (40,20,30)
/*const HeaderTitle = styled.h2`
    font-size: 1.5rem;
    line-height: 1.08;
    margin: 0 0 5px;
`;*/

const HeaderSubtitle = styled.p`
    font-size: 14px;
    font-weight: normal;
    line-height: 1.29;
    letter-spacing: 0.25px;
    color: !Reskin ? '#767676' : '#00000'; 
    margin: 0;
`;

const ModalHeader = (title, subTitle, Reskin) => (
    <HeaderContainer>
            {!Reskin && <Title size="large" viewport={InHomeUtils.getdeviceType()} primitive="h2" color="black" class="fll">{title}</Title>}
            {Reskin && <TitleLockup
                    data={{
                        eyebrow: false,
                        title: {
                            bold: false,
                            size: 'titleLarge',
                            children: title,
                            primitive: "h2",
                        }
                    }} />}
        <HeaderSubtitle style={{marginTop:'24px'}}>{subTitle}</HeaderSubtitle>
    </HeaderContainer>
);

const ButtonRow = styled.div`
    width: 100%;
    text-align: center;
    margin: ${calculateRem(20, 0)};

    @media only screen and (min-width: ${breakpoints.md}) {
        margin: ${calculateRem(15, 0,0,0)};
      };

      & ${Button} {
        margin: 0;
      }

    // & ${Button} {
    //     margin: 0;
    //     border-radius: 0;
    //     width: ${calculateRem(240)};
    //     border: 0;
    //     padding-top: ${calculateRem(14)};
    //     padding-bottom: ${calculateRem(14)};
    //     background: #333333;
    //     line-height: 1.25;
    //   }
    //   & ${Button}[disabled] {
    //     background: #b4b4b4;
    //   }
`;

const ReviewButtonRow = styled.div`
      text-align: center;
      margin: ${calculateRem(5, 0)};
      height: ${calculateRem(18)};
`;

const ReviewButton = styled.div`
    color: #00000;
    background: transparent;
    font-family: Verizon-NHG-eDS;
    font-size: 16px;
    font-weight: 400;
    line-height: 20px;
    margin-left: 8px;
    border: 0;
    padding: 0;
    pointer: cursor;
    display: inline-block;
    text-decoration: underline;
    float:left;
`;


class FiosFivePickChannelsComponent extends Component {
    constructor(props) {
        super(props);
        console.log(props);
        this.state = {
            selectedChannels: props.selectedChannels,
            isAddButtonDisaled: props.selectedChannels.length === 5 ? false : true
        };
        this.compChanListBtnVisible = false;
        this.isReskin = this.props.buildProductState.isReskin && this.props.lqState && this.props.lqState.runtimeKey && this.props.lqState.runtimeKey.EnableReskin === 'Y';
    }
    
    componentDidUpdate() {
        //focus on My Complete Channel Listing when shown - accessibility
        setTimeout(()=>{
            let compChanListBtn = document.getElementById('complete-channel-listing');
            if (compChanListBtn && !this.compChanListBtnVisible) {
                this.compChanListBtnVisible = true;
                compChanListBtn.focus();
            } else if (!compChanListBtn) {
                this.compChanListBtnVisible = false;
            }
        },500)
    }

    componentDidMount(){
        //focus close button by default - accessibility
        let closeBtnEl = document.getElementsByClassName('styles_closeButton__20ID4');
        closeBtnEl && closeBtnEl.length && closeBtnEl[0].focus();

        const { vhoParams, dispatch, lqState, visitId, visitorId } = this.props;
        (vhoParams.lfa === undefined || vhoParams.vhoName === undefined) && action.fetchRegionId(dispatch, lqState.selectedState.zip, lqState.selectedAdr.city, visitId, visitorId);
    }



    getSelectedChannels = (channels) => {
        this.setState({
            selectedChannels: channels,
            isAddButtonDisaled: channels.length === 5 ? false : true,
            showReview: false
        });
    }

    removeChannel = (channel) => {
        const selectedChannels = this.state.selectedChannels;
        let channelIndex = -1;
        selectedChannels.map((cl, index) => {
            if(cl.id === channel.id ) {
                channelIndex = index;
            }
            return true;
        });
        selectedChannels.splice(channelIndex, 1);

        this.setState({
            selectedChannels: selectedChannels,
            isAddButtonDisaled: selectedChannels.length === 5 ? false : true
        });

        //added
        this.props.onRemoveChannel(selectedChannels);
        updateSCTags("yftv remove- " + channel.name);
    }

    addToPlan = () => {
        console.log(this.state.selectedChannels);
        this.props.addToPlan(this.state.selectedChannels);
        action.setFiosFiveModalDetails('intro',this.state.selectedChannels, this.props.dispatch)
        updateSCTags("add to plan");
    }

    switchToChannelList = (v) => {
        this.setState({
            showReview: v
        });
        updateSCTags("my complete channel listing");
    }

    onCompChanListingClick = () => {        
        this.switchToChannelList(true);
    };

    onCompChanListingKeyDown = (e) => {
        if (e.keyCode === 13 || e.keyCode === 32) {            
            e.preventDefault();
            this.onCompChanListingClick();
        }
    }
   
    render() {
        let Reskin = this.isReskin;
        const title = 'Choose your 5 favorite channels';
        //const ifManageChannels = this.props.flowFor === 'manage' ? ' Changes effective on June 1, 2022.' : '';
        const subTitle = Reskin ? "Browse through popular, action & drama, comedy and more to find the 5 channels you love. Remember you'll also get the major broadcast networks such as ABC, CBS, CW, FOX, MyNet, NBC, Telemundo and Univision." : "No matter what channels you choose, you’ll still get the major broadcast networks, like ABC, CBS, CW, FOX, MyNet, NBC, Telemundo and Univision.";

        return (            
            <React.Fragment>
            <div>
                {this.state.showReview ?  
                    <FiosFiveChannelReviewComponent
                        tabIndex='0' 
                        dispatch={this.props.dispatch}
                        channelImgPath={this.props.channelImgPath} 
                        selectedChannels={this.state.selectedChannels} 
                        back={() => this.switchToChannelList(false)}
                        visitId={this.props.visitId}
                        visitorId={this.props.visitorId}
                        vhoParams={this.props.vhoParams}
                        packageDetails={this.props.packageDetails}
                        lqState={this.props.lqState}
                        product={this.props.product}
                        buildProduct={this.props.buildProductState}
                    /> : 

                    <React.Fragment>
                    {ModalHeader(title, subTitle, Reskin)}
<ModalBody>
                    <SelectedChannelsDisplay tabIndex='0' channelImgPath={this.props.channelImgPath} selectedChannels={this.state.selectedChannels} removeChannel={this.removeChannel}  buildProductState={this.props.buildProductState}
                        lqState={this.props.lqState}></SelectedChannelsDisplay>
                    <ChannelListComponent 
                        tabIndex='0' 
                        channelImgPath={this.props.channelImgPath} 
                        channelsData={this.props.channelsData} 
                        selectedChannels={this.getSelectedChannels} 
                        setSelectedChannels={this.state.selectedChannels}
                        onSearchInput={this.props.onSearchInput}
                        searchSuggestions={this.props.searchSuggestions}
                        matchedChannelList={this.props.matchedChannelList}
                        buildProductState={this.props.buildProductState}
                        lqState={this.props.lqState}
                    />
</ModalBody>
                    <ReviewButtonRow>
                    {!this.state.isAddButtonDisaled && 
                        
                            <ReviewButton id="complete-channel-listing" tabIndex="0" aria-live="assertive" role='button' onClick={this.onCompChanListingClick} onKeyDown={this.onCompChanListingKeyDown}><span className="screen-reader-only">Open modal showing</span>My complete channel listing</ReviewButton>
                        
                    }
                    </ReviewButtonRow>
                    <ButtonRow>
                        <div className='modalFooterButtonReskin2'>
                        <Button id="addToPlan" style={{float:'left'}} onClick={this.addToPlan} disabled={this.state.isAddButtonDisaled}>Add to plan</Button>
                        </div>   
                    </ButtonRow>
                    </React.Fragment>
                }         
                </div>
            </React.Fragment>
        );
    }
}
const mapStateToProps = (state) => {
    return {
        lqState: state.loopQual,
        buildProductState: state.buildProduct,
    }
}
export default connect(
    mapStateToProps
)(FiosFivePickChannelsComponent);


 